import Vue from 'vue'
import day from 'dayjs'

Vue.filter('day', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  if (dataStr) {
    return day(dataStr).format(pattern)
  }
  return ''
})

Vue.filter('code', function (dataStr) {
  if (dataStr) {
    if (dataStr === 'HANYANG_OA') {
      return '瀚洋oa'
    }
    return dataStr
  }
  return ''
})



// WEBPACK FOOTER //
// ./src/utils/filter.js